<ion-content>
  <guest-info-component></guest-info-component>
</ion-content>
